import { useAuthSelector } from 'app/data/auth';
import { QueryKey, useQuery, UseQueryOptions } from 'react-query';
import { sdk } from 'app/sdk';
import { Contact } from 'types/contact';
import { DevicesPageResponse } from 'types/device';
// import { ContactsPageResponse } from 'types/contact';
import contactQueryKeys from './contactQueryKeys';

interface QueryParams {
  skip?: number;
  take?: number;
  orderBy?: any;
  filters?: any;
  // mask?: any;
  options?: Omit<
    UseQueryOptions<
      { name: string; number: string }[],
      Error,
      { name: string; number: string }[],
      QueryKey
    >,
    'queryKey' | 'queryFn'
  >;
  // quick?: boolean;
}

export const useMaybeContactsQuery = ({ options }: QueryParams) => {
  // returns list of contacts
  // - just get ALL contacts+relations
  // - TODO v2: can be filtered/etc
  const authState = useAuthSelector();
  const queryKey = contactQueryKeys.maybeList();

  const query = useQuery(
    queryKey,
    () =>
      sdk.contact.query.maybeContacts({}, { authToken: authState.auth_token }),
    {
      ...options,
      // enabled: authState?.auth_token_decoded?.owner_id ? true : false,
      // prevents pagination from looking like a hard load;
      //  - keeps previous data displayed until new data arrives
      keepPreviousData: true,
    },
  );

  return {
    ...query,
    queryKey,
  };
};

export default useMaybeContactsQuery;
